module.exports = __webpack_public_path__ + "img/public/SiteIcons/mailIcon.svg?55a44127";